import { Link } from 'react-router-dom';


export default function MenuLink(props){
    return (
        <Link to={props.to} replace={true} className={"whitespace-pre text-center text-xs sm:text-md lg:text-lg font-bold border-2 border-black rounded-md shadow-yellow py-1 px-1 md:px-2 mr-2 sm:mr-5 hover:bg-yellow " + (props.isSelected === 'true'? "bg-yellow" : "")}>{props.title}</Link>
 
    );
}